// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__FSmHc","wrapper":"footer_wrapper__PueMR","logo":"footer_logo__9rbFf"};